export const MAPBOX_TOKEN =
  'pk.eyJ1IjoiaWx5YWR2dHJ4MSIsImEiOiJjbHc1MDZzdG8xYXlyMmlweW4wdm5hMHBsIn0.JWHEI9hGWXNie48ZLYj77Q'
export const MAPBOX_STYLE = 'mapbox://styles/mapbox/outdoors-v12'
